import type { ReactNode } from 'react'

type Props = {
  open: boolean
  children: ReactNode
  className?: string
  /** Applied only while open (e.g. vertical spacing). */
  classNameWhenOpen?: string
  ariaHiddenWhenClosed?: boolean
}

/** Animated height collapse — keeps content mounted; use instead of `{open ? … : null}` for expandables. */
export default function CollapseSlot({
  open,
  children,
  className = '',
  classNameWhenOpen = '',
  ariaHiddenWhenClosed = true,
}: Props) {
  return (
    <div
      className={`ui-collapse-slot${open ? ' ui-collapse-slot--open' : ''}${
        className ? ` ${className}` : ''
      }${open && classNameWhenOpen ? ` ${classNameWhenOpen}` : ''}`}
      aria-hidden={ariaHiddenWhenClosed && !open ? true : undefined}
    >
      <div className="ui-collapse-slot__inner">{children}</div>
    </div>
  )
}
